import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Add = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20ZM11 8V15H12V16H9V15H10V9H9V8H10H11ZM11 6V5H10V6H11Z"
  />,
  'Info'
)

export default Add
